import { render, staticRenderFns } from "./trade_card.vue?vue&type=template&id=701e427a&scoped=true&"
import script from "./trade_card.vue?vue&type=script&lang=js&"
export * from "./trade_card.vue?vue&type=script&lang=js&"
import style0 from "./trade_card.vue?vue&type=style&index=0&id=701e427a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e427a",
  null
  
)

export default component.exports